import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About me`}</h2>
    <p>{`With 15 years of experience in mobile and web development, specializing in full-stack engineering with Next.js, React, React Native, and Node.js, I'm deeply passionate about cutting-edge technologies, including machine learning and entrepreneurship. As the founder of Rokkey digital agency and dalil-turkey.com, I build scalable products and help businesses and startups grow.`}</p>
    <p>{`My proven track record includes independently implementing and testing software components, contributing to large-scale projects like the React Native app for Abu Dhabi City Municipality.`}</p>
    <p>{`Fluent in English with excellent communication and problem-solving abilities, I'm adaptable to new technologies. Notable contributions to the open-source community include the Gatsby Markdown Blog Starter and the React Native Location Track npm package.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      